import React from "react";
import { Container } from "reactstrap";

import VVSTable from "components/form-control/VVSTable";
import httpService from "services/httpService";

const ExtensionManagement = () => {
  const beforeSaveInlineEdit = row => {
    const { extension, objectId } = row;
    httpService.put(`/parse/classes/Employee/${objectId}`, { extension });
  };

  return (
    <div className="page-content">
      <Container fluid>
        <VVSTable
          name="ExtensionManagement"
          title="Quản lý extention"
          enableInlineEdit
          disableAdd
          beforeSaveInlineEdit={beforeSaveInlineEdit}
        />
      </Container>
    </div>
  );
};

export default ExtensionManagement;
